import * as React from 'react';
import { shouldThrowError } from './utils.mjs';

var ensurePreventErrorBoundaryRetry = function ensurePreventErrorBoundaryRetry(options, errorResetBoundary) {
  if (options.suspense || options.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      options.retryOnMount = false;
    }
  }
};

var useClearResetErrorBoundary = function useClearResetErrorBoundary(errorResetBoundary) {
  React.useEffect(function () {
    errorResetBoundary.clearReset();
  }, [errorResetBoundary]);
};

var getHasError = function getHasError(_ref) {
  var result = _ref.result,
      errorResetBoundary = _ref.errorResetBoundary,
      useErrorBoundary = _ref.useErrorBoundary,
      query = _ref.query;
  return result.isError && !errorResetBoundary.isReset() && !result.isFetching && shouldThrowError(useErrorBoundary, [result.error, query]);
};

export { ensurePreventErrorBoundaryRetry, getHasError, useClearResetErrorBoundary };